import { render, staticRenderFns } from "./AuthorizedRequestsReport.vue?vue&type=template&id=ec069810&scoped=true"
import script from "./AuthorizedRequestsReport.vue?vue&type=script&lang=js"
export * from "./AuthorizedRequestsReport.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedRequestsReport.vue?vue&type=style&index=0&id=ec069810&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec069810",
  null
  
)

export default component.exports